import { Component, OnInit, Input } from '@angular/core';
import { LangService } from '../../core/lang.service';
import { LoginGuardService } from '../../api/login-guard.service';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() hasLinks:boolean = true;
  @Input() hasComments:boolean = true;

  constructor(
    public lang: LangService,
    private loginGuard: LoginGuardService
  ) { }

  ngOnInit() {
    
  }

  supportReqActivate(){
    this.loginGuard.supportReqActivate()
  }

  clang(){
    return this.lang.getCurrentLanguage();
  }

}
